import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHypertrackerApiMenuMobileIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.3333 11.3333L14.6667 8L11.3333 4.66667M4.66668 4.66667L1.33334 8L4.66668 11.3333M9.33334 2L6.66668 14",
		stroke: "#1A1B23",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.3333 11.3333L14.6667 8L11.3333 4.66667M4.66668 4.66667L1.33334 8L4.66668 11.3333M9.33334 2L6.66668 14",
		stroke: "white",
		strokeOpacity: .5,
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgHypertrackerApiMenuMobileIcon;
